// registerParcelsExcelListener.ts
import { Parcel } from "../services/parcelTypes";
import { exportParcelsToExcel } from "./excelParcelsModule";

type GetParcels = () => Parcel[];

export const registerParcelsExcelListener = (getParcels: GetParcels) => {
    const handler = (event: MessageEvent) => {
        if (event.data?.message !== "excel") return;

        const parcels = getParcels();
        exportParcelsToExcel(parcels);
    };

    window.addEventListener("message", handler);

    return () => {
        window.removeEventListener("message", handler);
    };
};